import { Component } from '@angular/core';
import { ModalService } from '../core/services/modal.service';
import { AlertService } from '../core/services/alert.service';
import { OktaRoles } from '../core/services/auth.service';

@Component({
    selector: 'app-admin-roles',
    templateUrl: './admin-roles.component.html',
    styleUrls: ['./admin-roles.component.scss'],
})
export class AdminRolesComponent {
    roles = [];

    userList = [
        {
            name: "Sean O'Leary",
            email: 'soleary@srsacquiom.com',
            role: 'Senior Product Designer, Product',
            addedBy: 'Mitchell Eckberg',
            timeAdded: new Date('2024-11-15T12:05:00').toDateString(),
        },
        {
            name: 'Maddie Birrenkott',
            email: 'mbirrenkott@srsacquiom.com',
            role: 'Product Owner, Product',
            addedBy: 'Mitchell Eckberg',
            timeAdded: new Date('2024-11-15T12:04:00').toDateString(),
        },
        {
            name: 'Phillip Polasek',
            email: 'ppolasek@srsacquiom.com',
            role: 'Senior Software Engineer, Engineering',
            addedBy: 'Maddie Birrenkott',
            timeAdded: new Date('2024-11-15T12:03:00').toDateString(),
        },
    ];

    constructor(
        private modal: ModalService,
        private alert: AlertService,
    ) {
        this.roles = this.getRolesFromEnum();
    }

    private getRolesFromEnum(): { name: string }[] {
        return Object.values(OktaRoles).map((role) => ({
            name: role,
        }));
    }

    async openExportModal(): Promise<void> {
        const defaultFileName = `Admin Tool Permission Report ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString().replace(/:/g, '_')}`;

        const result = await this.modal.export({
            title: 'Export Permission Report',
            initialFileName: defaultFileName,
            confirmText: 'Export',
            cancelText: 'Cancel',
        });

        if (result === 'export') {
            this.exportReport(result);
            this.alert.show({
                title: '',
                description: `Report successfully exported.`,
                connotation: 'success',
                icon: 'check_circle',
            });
        }
    }

    exportReport(fileName: string): void {
        // TO-DO: Implement the export logic here
        console.log(`Exporting report as: ${fileName}.xlsx`);
    }
}
